<script lang="ts">
  export let planName = '';

  const loremIpsums: {title: string; text: string}[] = [
    {title: 'Title', text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'},
    {
      title: 'Description',
      text: 'Lectus arcu bibendum at varius vel pharetra vel turpis nunc. Et magnis dis parturient montes nascetur ridiculus mus mauris. Integer eget aliquet nibh praesent tristique. Elementum tempus egestas sed sed risus pretium quam vulputate. Pulvinar sapien et ligula ullamcorper malesuada. Lorem ipsum dolor sit amet consectetur. Est velit egestas dui id ornare arcu odio ut sem. Est ultricies integer quis auctor elit sed vulputate mi. Nullam ac tortor vitae purus faucibus. Eget velit aliquet sagittis id consectetur.'
    },
    {
      title: 'Content',
      text: 'Integer vitae justo eget magna fermentum. Ac tincidunt vitae semper quis. Blandit volutpat maecenas volutpat blandit aliquam. Ornare aenean euismod elementum nisi quis eleifend. Malesuada proin libero nunc consequat interdum varius sit. Ac ut consequat semper viverra nam libero justo laoreet sit. Interdum posuere lorem ipsum dolor sit amet. In massa tempor nec feugiat nisl pretium fusce. Tellus id interdum velit laoreet id donec ultrices tincidunt arcu. Libero nunc consequat interdum varius sit amet mattis vulputate enim. Nec nam aliquam sem et tortor consequat. Sed odio morbi quis commodo odio aenean sed. Odio eu feugiat pretium nibh ipsum consequat nisl vel. Sagittis nisl rhoncus mattis rhoncus urna. Sagittis orci a scelerisque purus semper eget duis at tellus.'
    },
    {
      title: 'Example',
      text: 'Luctus venenatis lectus magna fringilla urna porttitor. Vel quam elementum pulvinar etiam non quam lacus. Facilisi etiam dignissim diam quis enim lobortis scelerisque fermentum dui. Quam pellentesque nec nam aliquam sem et tortor consequat. Risus pretium quam vulputate dignissim suspendisse in est ante. Praesent tristique magna sit amet purus. Consectetur purus ut faucibus pulvinar. Integer enim neque volutpat ac tincidunt vitae semper quis lectus. Porta lorem mollis aliquam ut porttitor leo. At varius vel pharetra vel turpis nunc eget. Commodo odio aenean sed adipiscing diam donec. Turpis egestas sed tempus urna. Etiam erat velit scelerisque in.'
    }
  ];
</script>

<div class="relative h-full w-full">
  <div class="absolute left-0 top-0 z-10 flex h-full w-full items-center justify-center bg-white/40">
    <div class="grid items-center gap-2 p-4">
      <div class="flex justify-center pb-8">
        <div class="flex items-center rounded-full bg-primary p-5 text-4xl text-white">
          <i class="fa-solid fa-lock"></i>
        </div>
      </div>
      <p class="text-center text-lg font-bold text-zinc-700">Upgrade your plan to access more features.</p>
      <div class="flex justify-center">
        <a
          href="/pricing"
          target="_blank"
          class="flex items-center gap-2 rounded-lg bg-primary px-5 py-2.5 text-sm font-medium text-white"
        >
          See All Plans
          <i class="fa-solid fa-chevron-right"></i>
        </a>
      </div>
    </div>
  </div>
  <div class="h-full w-full blur">
    <div class="flex h-16 w-full items-center border-b border-b-zinc-200 px-4 dark:border-b-zinc-600">
      <h1 class="text-md font-bold">Upgrade Plan</h1>
      <div class="ml-auto flex items-center">
        <button class="bg-rose-500 px-3 py-1 font-medium text-zinc-100" data-note="this does nothing">
          Download
        </button>
      </div>
    </div>
    <div class="h-[calc(100%-4rem)] w-full overflow-auto p-4">
      <div class="flex h-full w-full justify-center">
        <div class="h-full w-full max-w-[40rem]">
          <div class="grid gap-10 pb-16">
            {#each loremIpsums as loremIpsum}
              <div class="grid gap-2">
                <h1 class="text-3xl font-bold">{loremIpsum.title}</h1>
                <p class="text-justify">{loremIpsum.text}</p>
              </div>
            {/each}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
